<template>
  <div class="text-container" :id="id">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'CollectionParagraph',
  props: {
    id: {
      type: String,
      default: undefined
    }
  }
}
</script>

<style lang="less" scoped>
.text-container {
  font-style: italic;
  font-size: 18px;
  margin-bottom: 2em;
}
</style>
